// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w4k3","type":"styles_type__YLBDr","choices":"styles_choices__2qNK-"};